module.exports = __webpack_public_path__ + "img/google.4f0d1ba6.svg";